import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'taskListResourcePlanner';

const taskListResourcePlannerService = {
  getProjects: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/projects`,
      data,
    });
  },

  getV2Projects: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/v2/projects`,
      data,
    });
  },

  getEvents: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/events`,
      data,
    });
  },

  getV2Events: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/v2/events`,
      data,
    });
  },

  getReportEvents: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/events/reportEvents`,
      data,
    });
  },

  updateEvent: (data, id) => {
    return request({
      method: Methods.PATCH,
      resource: `${baseURL}/${encodeURIComponent(id)}`,
      data,
    });
  },
};
export default taskListResourcePlannerService;
